<template>
	<div class="range-list">
		<div
		     v-for="(item, index) in items"
		     :key="item.name"
		     :class="{'list-item': true, selected:item.selected, active: index === selected}"
		     @click="selectItem(index)"
			 @keydown.enter="selectItem(index)"
			 tabindex="0"
		>{{ item.label }}</div>
	</div>
</template>

<script>
export default {
	name: "RangeList",
	props:{
		'items':{
			type: Array
		}
	},
	computed:{
		selected(){
			const items = this.items;
			let selected = null;
			for(let i=0; i < items.length; i++){
				const item = items[i];
				if(item.selected) selected = i;
			}
			return selected;
		}
	},
	methods:{
		selectItem(index) {
			const items = this.items;
			const shouldDeselect = this.items[index].selected && index == this.selected
			for(let i=0; i < items.length; i++){
				if(shouldDeselect) {
					items[i].selected = false;
				} else {const item = items[i];
					item.selected = i <= index;}
				
			}
			this.$emit('select', items[index]);
		}
	}
}
</script>

<style lang="scss">
	.range-list{
		// padding: 4px 0;
		.list-item {
			display: flex;
			justify-content: center;
			align-content: center;
			flex-wrap: wrap;
			height: 35px;
			padding: 0px 8px;
			background-color: #fff;
			cursor: pointer;
			user-select: none;
			&.selected {
				background-color: #d5d5d5;
				&.active{
					background-color: red;
					color: #fff;
				}
			}
		}
	}
	[mode='tablet'],
	[mode='mobile'] {
     .range-list {
		padding: 4px 0;
	 }
	}
</style>
